import React from "react";

interface DropdownProps {
  options: Array<any>;
  handleSelection: (value: any) => void;
  selectedValue: any;
  customClass?: string;
}

const Dropdown = (props: DropdownProps) => {
  return (
    <select
      className={`dropdown ${props.customClass}`}
      onChange={(e) => props.handleSelection(e.target.value)}
      data-track="dropdown"
    >
      {props.options.map((option: any, index: number) => (
        <option key={option.value} value={option.value}>
          {option.name}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
